export const selectWorkspaceDocuments = (state) =>
  state.workspaceV2.documents;

export const selectWorkspaceDocumentsIsLoading = (state) =>
  state.workspaceV2.isLoading;

export const selectWorkspaceDocumentsIsLoadingMore = (state) =>
  state.workspaceV2.isLoadingMore;

export const selectWorkspaceDocumentsIsLastPage = (state) =>
  state.workspaceV2.isLastPage;

export const selectWorkspaceDocumentsPageNumber = (state) =>
  state.workspaceV2.pageNumber;
